<template>
    <v-row class="d-flex flex-column justify-center align-center wellbeing-container pa-0 ma-0">
        <v-icon size="50">lock</v-icon>
        <div class="d-flex input-wrapper mt-4 mb-8">
            <v-text-field
                required
                solo
                flat
                background-color="white"
                placeholder="email"
                class="email-input"
                :error-messages="errorMessage"
                v-model="email"
                :disabled="isUpdating"
            >
            </v-text-field>
            <v-btn height="100%" depressed @click="validateEmail" :disabled="isUpdating">
                <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
        </div>
        <p
          id="registrationMessage"
          class="registration-message">
          Please access the secure content by inputting your staff email each time you visit this page. Your progress through the modules will be saved after each visit.
          <br/><br/>
          On the following page you will be prompted to enter your first and last names. Immediately after your last name, please enter the name of your school in the same field (see example below).
          <v-img
            class="mt-4"
            :src="wellbeingExampleURL">
          </v-img>
        </p>
    </v-row>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapState,
} from 'vuex';

export default {
  name: 'Wellbeing',
  data() {
    return {
      email: null,
      errorMessage: '',
    };
  },
  computed: {
    ...mapState([
      'isUpdating',
    ]),
    ...mapGetters([
      'queryParams',
    ]),
    wellbeingExampleURL() {
      return `${this.$getServerUrl()}hosted/images/wellbeing_middleware_example.png`;
    },
  },
  methods: {
    ...mapActions([
      'validateWellbeing',
    ]),
    async validateEmail() {
      const emailRegex = /[a-zA-Z0-9_\-.+]+@[a-zA-Z0-9-]+.[a-zA-Z]+/;
      if (emailRegex.test(this.email)) {
        this.errorMessage = '';
        await this.validateWellbeing({ email: this.email, courseHash: this.$route.params.courseHash });
      } else {
        this.errorMessage = 'Please enter a valid email address';
      }
    },
  },
};
</script>

<style>
.wellbeing-container {
    height: 100vh;
    width: 100%;
    background-color: #F2F2F2;
}

.input-wrapper {
    height: 3em;
}

.email-input {
    flex: 0 1 auto;
    height: 100%;
}

.email-input input {
    padding-left: 15px;
}

.registration-message {
  width: 35em;
  text-align: center;
}

</style>
